var inherit = require("../../general.js").inherit;
var SortedMap = require("../../collections/sortedMap.js");
var ObservableValue = require("./../observableValue.js");
var TreeEvent = require('./treeEvent.js');

var ObservableTreeValue = function(treeNode, name, owner, validator){
    ObservableValue.call(this, validator);
    this._treeNode = treeNode;
    this._name = name;
    this._owner = owner || false;
    this.handlers.bubble = null;
};
inherit(ObservableTreeValue, ObservableValue);
ObservableTreeValue.createNewFunction = ObservableValue.createNewFunction;
ObservableTreeValue.prototype.getName = function(){ return this._name; };
ObservableTreeValue.prototype.getTreeNode = function(){ return this._treeNode; };
ObservableTreeValue.prototype.isOwner = function(){ return this._owner; };

ObservableTreeValue.prototype.onBubble = function(key, handler, priority){
    console.assert(key != null && handler && typeof handler == "function", "Scheduling handler expects a valid key + handler function");
    if(!this.handlers.bubble) this.handlers.bubble = new SortedMap();
    this.handlers.bubble.put(key, handler, priority || 0);
};

ObservableTreeValue.prototype.replaceWithoutTriggers = function(newVal){
    this.set(newVal, true);
}

ObservableTreeValue.prototype.set = function(val, noObservations){
    if (!this.nonPersistent && this._treeNode.root && this._treeNode.root.isLocked && this._treeNode.root.isLocked(true)) return; // TODO: not very clean 
    if (val !== this._value){
        var self = this;
        var old = this._value;
        var validated = !this.validator || this.validator(val, old);
        if(validated) {
            this._value = val;

            if (this._owner){
                if (old && old.isObservableTreeNode) old._removeTreeNode();
                if (val && val.isObservableTreeNode) val._addTreeNodeTo([this]);
            } else {
                if (old && old.isObservableTreeNode) old.referrers.remove([this]);
                if (val && val.isObservableTreeNode) val.referrers.add([this]);
            }

            if(!noObservations){
                var event = new TreeEvent("change", this, undefined, val, old);
                if (this._treeNode.root && this._treeNode.root.logEvent) this._treeNode.root.logEvent(event);

                this.handlers.change && this.handlers.change.forEach(function(k, handler){
                    handler.call(self, val, old);
                });

                event.trigger();
            }
        } else {
            if(!noObservations){
                this.handlers.setFail && this.handlers.setFail.forEach(function(k, handler){
                    handler.call(self, val, old);
                });
            }
        }
        return validated;
    } else return true;
};

module.exports = ObservableTreeValue;